import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BaseButton from "../../../../components/BaseButton";
import BaseIcon from "../../../../components/BaseIcon";
import useModalActions from "../../../../hooks/useModalActions";
import { MODAL_TYPES } from "../../../../utils/emitter";
import PersonalAccount from "../../../../store/PersonalAccount";
import Points from "../../../../store/Points";
import { buildShareLink, shareApp } from "../../../../utils/share";
import "./style.scss";

// Нижний блок ЛК (дизайн Figma): шеринг реф-ссылки + статистика приглашений.
// Баланс баллов вынесен в PointsScale (верх ЛК), кнопки покупок — под каждую игру.
export default observer(function LoyaltyActions() {
  const { t } = useTranslation();
  const { openModal } = useModalActions();

  useEffect(() => {
    Points.fetchReferralStats();
  }, []);

  const share = async () => {
    await shareApp({
      url: buildShareLink(PersonalAccount.user?.refCode),
      text: t("share.invite_text"),
      sentryTag: "LoyaltyActions",
    });
  };

  const stats = Points.referralStats;

  return (
    <div className="loyalty-actions">
      <div className="loyalty-actions__share-col">
        <div className="loyalty-actions__share-title">
          {t("loyalty.share_title")}
        </div>
        <div className="loyalty-actions__share-row">
          <BaseButton onClick={share} className="loyalty-actions__share-btn">
            <BaseIcon
              name="share_gradient_white"
              className="loyalty-actions__share-icon"
            />
            {t("loyalty.share_btn")}
          </BaseButton>
          <span
            className="loyalty-actions__instruction"
            onClick={() => openModal(MODAL_TYPES.POINTS_INSTRUCTION)}
          >
            {t("loyalty.instruction_link")}
          </span>
        </div>
      </div>

      <div className="loyalty-actions__stats">
        <div className="loyalty-actions__stats-title">
          {t("loyalty.ref_stats_title")}
        </div>
        <div className="loyalty-actions__stats-cards">
          <div className="loyalty-actions__stat-card">
            <span className="loyalty-actions__stat-value">
              {stats?.passedTest ?? 0}
            </span>
            <span className="loyalty-actions__stat-label">
              {t("loyalty.ref_stats.passed")}
            </span>
          </div>
          <div className="loyalty-actions__stat-card">
            <span className="loyalty-actions__stat-value">
              {stats?.boughtGame ?? 0}
            </span>
            <span className="loyalty-actions__stat-label">
              {t("loyalty.ref_stats.bought")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});
